import { LegalShell, Section, ToConfirm } from "@/components/legal/LegalShell";

export default function MentionsLegales() {
  return (
    <LegalShell title="Mentions légales" subtitle="Informations relatives à l'éditeur du parcours de simulation et à son activité réglementée." testid="page-mentions-legales">
      <Section title="Éditeur du parcours de simulation" testid="legal-editeur">
        <p><strong>Teddy FORTASSIER</strong> — courtier en crédit immobilier.</p>
        <p>SIREN : 844 809 020 — RCS Béziers<br />Adresse : 37 rue de la Rascasse, 34410 Sérignan<br />Contact : <a href="mailto:teddy.fortassier@bypretto.fr" className="underline">teddy.fortassier@bypretto.fr</a></p>
      </Section>

      <Section title="Activité réglementée" testid="legal-orias">
        <p>Immatriculation ORIAS n° <strong>19002309</strong> (registre consultable sur <a href="https://www.orias.fr" target="_blank" rel="noreferrer" className="underline">www.orias.fr</a>) en qualité de :</p>
        <ul className="list-disc pl-5">
          <li>mandataire d'intermédiaire en opérations de banque et en services de paiement (MIOBSP) ;</li>
          <li>mandataire d'intermédiaire d'assurance (MIA).</li>
        </ul>
        <p>Mandant pour ces deux activités : <strong>FINSPOT</strong> — RCS Paris 825 077 886, ORIAS 17000916, 42 rue de Paradis, 75010 Paris.</p>
        <ToConfirm>le périmètre exact du mandat FINSPOT (exclusivité, activités couvertes) et la mention éventuelle de l'autorité de contrôle (ACPR) à faire valider sur la base du document d'entrée en relation.</ToConfirm>
      </Section>

      <Section title="Médiation" testid="legal-mediation">
        <p>Médiateur indiqué dans le document d'entrée en relation : <strong>CMAP</strong> — Centre de Médiation et d'Arbitrage de Paris, 39 avenue Franklin D. Roosevelt, 75008 Paris.</p>
        <ToConfirm>les coordonnées de réclamation préalable : deux adresses différentes figurent dans le document d'entrée en relation et sur le site Pretto ; aucune n'est publiée tant qu'elle n'est pas confirmée par FINSPOT.</ToConfirm>
      </Section>

      <Section title="Nature du service" testid="legal-nature">
        <p>Le simulateur fournit une estimation <strong>indicative</strong> de faisabilité à partir des informations déclarées. Il ne constitue ni une offre de prêt, ni un accord de financement, ni un conseil personnalisé. L'analyse bancaire réelle repose sur des critères plus larges.</p>
      </Section>

      <Section title="Hébergement et plateforme technique" testid="legal-hebergement">
        <p>Le parcours est construit et déployé via la plateforme <strong>Emergent</strong> (plateforme de développement et de déploiement).</p>
        <ToConfirm>l'hébergeur effectif de production (raison sociale, adresse, pays et région d'hébergement des données) n'est pas déterminable depuis le code et doit être confirmé par écrit par Emergent avant publication.</ToConfirm>
      </Section>

      <Section title="Propriété intellectuelle" testid="legal-pi">
        <p>Les contenus, marques et éléments graphiques du parcours sont protégés. Toute reproduction non autorisée est interdite.</p>
        <ToConfirm>le titulaire des droits sur l'application Crédit Flow (éditeur logiciel) et la mention éventuelle de l'éditeur distinct de l'exploitant.</ToConfirm>
      </Section>
    </LegalShell>
  );
}
